var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.event)?_c('page-summary',{attrs:{"event":_vm.event,"headerText":"Ticket Summary"}}):_vm._e(),_vm._v(" "),_c('attendees-booking')],1)}
var staticRenderFns = []

export { render, staticRenderFns }